<div class="bg-image"></div>
<div class="row col-12 justify-content-center">
  <div class="row col-12 login-block">
    <div class="col-12 col-lg-6">
      <div class="col-12 text-center">
        <img src="assets/img/UnityC_RGB_app_72ppi.jpg" class="img-fluid" alt="UnityC Logo">
      </div>
      <div class="row col-12 padding-top-20 d-none d-lg-block login-page-text">
        <div>
          <span class="primary">C</span>onnect
          <span class="padding-left-10 padding-right-10">|</span>
          <span class="primary">C</span>ollaborate
          <span class="padding-left-10 padding-right-10">|</span>
          <span class="primary">C</span>ommunity
        </div>
        <div class="padding-top-20 primary">
          Your Secure Connection to Canadian Law Offices
        </div>
      </div>

    </div>
    <div class="col-12 col-lg-6">
      <div class="login-card">

      </div>

    </div>
  </div>
  <div  class="footer-block d-none d-lg-block justify-content-lg-center">
    <dp-footer></dp-footer>
  </div>
</div>
